// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TentangRouteImport } from './routes/tentang'
import { Route as SyaratKetentuanRouteImport } from './routes/syarat-ketentuan'
import { Route as KontakRouteImport } from './routes/kontak'
import { Route as KebijakanPrivasiRouteImport } from './routes/kebijakan-privasi'
import { Route as HariIniRouteImport } from './routes/hari-ini'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ZodiakIndexRouteImport } from './routes/zodiak.index'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as KalkulatorIndexRouteImport } from './routes/kalkulator.index'
import { Route as KalenderIndexRouteImport } from './routes/kalender.index'
import { Route as KalenderHijriahIndexRouteImport } from './routes/kalender-hijriah.index'
import { Route as JadwalSholatIndexRouteImport } from './routes/jadwal-sholat.index'
import { Route as JadwalImsakIndexRouteImport } from './routes/jadwal-imsak.index'
import { Route as JadwalBukaPuasaIndexRouteImport } from './routes/jadwal-buka-puasa.index'
import { Route as HarpitnasIndexRouteImport } from './routes/harpitnas.index'
import { Route as HariIndexRouteImport } from './routes/hari.index'
import { Route as EnIndexRouteImport } from './routes/en.index'
import { Route as ZodiakSignRouteImport } from './routes/zodiak.$sign'
import { Route as ToolsKalkulatorHariRouteImport } from './routes/tools.kalkulator-hari'
import { Route as ToolsHariSahabatRouteImport } from './routes/tools.hari-sahabat'
import { Route as ToolsHariPutusRouteImport } from './routes/tools.hari-putus'
import { Route as ToolsHariMenikahRouteImport } from './routes/tools.hari-menikah'
import { Route as ToolsHariLdrRouteImport } from './routes/tools.hari-ldr'
import { Route as ToolsHariLahirRouteImport } from './routes/tools.hari-lahir'
import { Route as ToolsHariJadianRouteImport } from './routes/tools.hari-jadian'
import { Route as ToolsCekWetonRouteImport } from './routes/tools.cek-weton'
import { Route as TanggalMerahYearRouteImport } from './routes/tanggal-merah.$year'
import { Route as LiburNasionalYearRouteImport } from './routes/libur-nasional.$year'
import { Route as JadwalSholatLokasiRouteImport } from './routes/jadwal-sholat.lokasi'
import { Route as JadwalSholatKotaRouteImport } from './routes/jadwal-sholat.$kota'
import { Route as JadwalImsakLokasiRouteImport } from './routes/jadwal-imsak.lokasi'
import { Route as JadwalImsakKotaRouteImport } from './routes/jadwal-imsak.$kota'
import { Route as JadwalBukaPuasaLokasiRouteImport } from './routes/jadwal-buka-puasa.lokasi'
import { Route as JadwalBukaPuasaKotaRouteImport } from './routes/jadwal-buka-puasa.$kota'
import { Route as HariSlugRouteImport } from './routes/hari.$slug'
import { Route as EnTodayRouteImport } from './routes/en.today'
import { Route as EnTermsRouteImport } from './routes/en.terms'
import { Route as EnTentangRouteImport } from './routes/en.tentang'
import { Route as EnPrivacyPolicyRouteImport } from './routes/en.privacy-policy'
import { Route as EnHariIniRouteImport } from './routes/en.hari-ini'
import { Route as EnContactRouteImport } from './routes/en.contact'
import { Route as EnAboutRouteImport } from './routes/en.about'
import { Route as EnSlugRouteImport } from './routes/en.$slug'
import { Route as DetailSlugRouteImport } from './routes/detail.$slug'
import { Route as CutiBersamaYearRouteImport } from './routes/cuti-bersama.$year'
import { Route as _diagEnAliasesRouteImport } from './routes/__diag.en-aliases'
import { Route as ZodiakCocokIndexRouteImport } from './routes/zodiak.cocok.index'
import { Route as KalenderYearIndexRouteImport } from './routes/kalender.$year.index'
import { Route as KalenderHijriahHyearIndexRouteImport } from './routes/kalender-hijriah.$hyear.index'
import { Route as HarpitnasSlugIndexRouteImport } from './routes/harpitnas.$slug.index'
import { Route as EnKalenderHijriahIndexRouteImport } from './routes/en.kalender-hijriah.index'
import { Route as EnHijriCalendarIndexRouteImport } from './routes/en.hijri-calendar.index'
import { Route as EnCalendarIndexRouteImport } from './routes/en.calendar.index'
import { Route as ZodiakTanggalSlugRouteImport } from './routes/zodiak.tanggal.$slug'
import { Route as ZodiakCocokPairRouteImport } from './routes/zodiak.cocok.$pair'
import { Route as KalenderYearSlugRouteImport } from './routes/kalender.$year.$slug'
import { Route as HarpitnasSlugMonthRouteImport } from './routes/harpitnas.$slug.$month'
import { Route as EnToolsWetonCheckRouteImport } from './routes/en.tools.weton-check'
import { Route as EnToolsKalkulatorHariRouteImport } from './routes/en.tools.kalkulator-hari'
import { Route as EnToolsDayCalculatorRouteImport } from './routes/en.tools.day-calculator'
import { Route as EnTanggalMerahYearRouteImport } from './routes/en.tanggal-merah.$year'
import { Route as EnRedDatesYearRouteImport } from './routes/en.red-dates.$year'
import { Route as EnPublicHolidaysYearRouteImport } from './routes/en.public-holidays.$year'
import { Route as EnLiburNasionalYearRouteImport } from './routes/en.libur-nasional.$year'
import { Route as EnJointLeaveYearRouteImport } from './routes/en.joint-leave.$year'
import { Route as EnDetailSlugRouteImport } from './routes/en.detail.$slug'
import { Route as EnCutiBersamaYearRouteImport } from './routes/en.cuti-bersama.$year'
import { Route as EmbedJadwalSholatKotaRouteImport } from './routes/embed.jadwal-sholat.$kota'
import { Route as EmbedJadwalImsakKotaRouteImport } from './routes/embed.jadwal-imsak.$kota'
import { Route as EmbedJadwalBukaPuasaKotaRouteImport } from './routes/embed.jadwal-buka-puasa.$kota'
import { Route as JadwalSholatKotaIndexRouteImport } from './routes/jadwal-sholat.$kota.index'
import { Route as JadwalSholatKotaKecRouteImport } from './routes/jadwal-sholat.$kota.$kec'
import { Route as JadwalImsakKotaIndexRouteImport } from './routes/jadwal-imsak.$kota.index'
import { Route as JadwalImsakKotaKecRouteImport } from './routes/jadwal-imsak.$kota.$kec'
import { Route as JadwalBukaPuasaKotaIndexRouteImport } from './routes/jadwal-buka-puasa.$kota.index'
import { Route as JadwalBukaPuasaKotaKecRouteImport } from './routes/jadwal-buka-puasa.$kota.$kec'
import { Route as KalenderHijriahHyearHmonthIndexRouteImport } from './routes/kalender-hijriah.$hyear.$hmonth.index'
import { Route as EnKalenderHijriahHyearIndexRouteImport } from './routes/en.kalender-hijriah.$hyear.index'
import { Route as EnHijriCalendarHyearIndexRouteImport } from './routes/en.hijri-calendar.$hyear.index'
import { Route as EnCalendarYearIndexRouteImport } from './routes/en.calendar.$year.index'
import { Route as KalenderHijriahHyearHmonthHdayRouteImport } from './routes/kalender-hijriah.$hyear.$hmonth.$hday'
import { Route as EnCalendarYearSlugRouteImport } from './routes/en.calendar.$year.$slug'
import { Route as EmbedJadwalSholatKotaIndexRouteImport } from './routes/embed.jadwal-sholat.$kota.index'
import { Route as EmbedJadwalSholatKotaKecRouteImport } from './routes/embed.jadwal-sholat.$kota.$kec'
import { Route as EmbedJadwalImsakKotaIndexRouteImport } from './routes/embed.jadwal-imsak.$kota.index'
import { Route as EmbedJadwalImsakKotaKecRouteImport } from './routes/embed.jadwal-imsak.$kota.$kec'
import { Route as EmbedJadwalBukaPuasaKotaIndexRouteImport } from './routes/embed.jadwal-buka-puasa.$kota.index'
import { Route as EmbedJadwalBukaPuasaKotaKecRouteImport } from './routes/embed.jadwal-buka-puasa.$kota.$kec'
import { Route as EnKalenderHijriahHyearHmonthIndexRouteImport } from './routes/en.kalender-hijriah.$hyear.$hmonth.index'
import { Route as EnHijriCalendarHyearHmonthIndexRouteImport } from './routes/en.hijri-calendar.$hyear.$hmonth.index'
import { Route as EnHijriCalendarHyearHmonthHdayRouteImport } from './routes/en.hijri-calendar.$hyear.$hmonth.$hday'

const TentangRoute = TentangRouteImport.update({
            id: '/tentang',path: '/tentang',getParentRoute: () => rootRouteImport
          })
const SyaratKetentuanRoute = SyaratKetentuanRouteImport.update({
            id: '/syarat-ketentuan',path: '/syarat-ketentuan',getParentRoute: () => rootRouteImport
          })
const KontakRoute = KontakRouteImport.update({
            id: '/kontak',path: '/kontak',getParentRoute: () => rootRouteImport
          })
const KebijakanPrivasiRoute = KebijakanPrivasiRouteImport.update({
            id: '/kebijakan-privasi',path: '/kebijakan-privasi',getParentRoute: () => rootRouteImport
          })
const HariIniRoute = HariIniRouteImport.update({
            id: '/hari-ini',path: '/hari-ini',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ZodiakIndexRoute = ZodiakIndexRouteImport.update({
            id: '/zodiak/',path: '/zodiak/',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const KalkulatorIndexRoute = KalkulatorIndexRouteImport.update({
            id: '/kalkulator/',path: '/kalkulator/',getParentRoute: () => rootRouteImport
          })
const KalenderIndexRoute = KalenderIndexRouteImport.update({
            id: '/kalender/',path: '/kalender/',getParentRoute: () => rootRouteImport
          })
const KalenderHijriahIndexRoute = KalenderHijriahIndexRouteImport.update({
            id: '/kalender-hijriah/',path: '/kalender-hijriah/',getParentRoute: () => rootRouteImport
          })
const JadwalSholatIndexRoute = JadwalSholatIndexRouteImport.update({
            id: '/jadwal-sholat/',path: '/jadwal-sholat/',getParentRoute: () => rootRouteImport
          })
const JadwalImsakIndexRoute = JadwalImsakIndexRouteImport.update({
            id: '/jadwal-imsak/',path: '/jadwal-imsak/',getParentRoute: () => rootRouteImport
          })
const JadwalBukaPuasaIndexRoute = JadwalBukaPuasaIndexRouteImport.update({
            id: '/jadwal-buka-puasa/',path: '/jadwal-buka-puasa/',getParentRoute: () => rootRouteImport
          })
const HarpitnasIndexRoute = HarpitnasIndexRouteImport.update({
            id: '/harpitnas/',path: '/harpitnas/',getParentRoute: () => rootRouteImport
          })
const HariIndexRoute = HariIndexRouteImport.update({
            id: '/hari/',path: '/hari/',getParentRoute: () => rootRouteImport
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/en/',path: '/en/',getParentRoute: () => rootRouteImport
          })
const ZodiakSignRoute = ZodiakSignRouteImport.update({
            id: '/zodiak/$sign',path: '/zodiak/$sign',getParentRoute: () => rootRouteImport
          })
const ToolsKalkulatorHariRoute = ToolsKalkulatorHariRouteImport.update({
            id: '/tools/kalkulator-hari',path: '/tools/kalkulator-hari',getParentRoute: () => rootRouteImport
          })
const ToolsHariSahabatRoute = ToolsHariSahabatRouteImport.update({
            id: '/tools/hari-sahabat',path: '/tools/hari-sahabat',getParentRoute: () => rootRouteImport
          })
const ToolsHariPutusRoute = ToolsHariPutusRouteImport.update({
            id: '/tools/hari-putus',path: '/tools/hari-putus',getParentRoute: () => rootRouteImport
          })
const ToolsHariMenikahRoute = ToolsHariMenikahRouteImport.update({
            id: '/tools/hari-menikah',path: '/tools/hari-menikah',getParentRoute: () => rootRouteImport
          })
const ToolsHariLdrRoute = ToolsHariLdrRouteImport.update({
            id: '/tools/hari-ldr',path: '/tools/hari-ldr',getParentRoute: () => rootRouteImport
          })
const ToolsHariLahirRoute = ToolsHariLahirRouteImport.update({
            id: '/tools/hari-lahir',path: '/tools/hari-lahir',getParentRoute: () => rootRouteImport
          })
const ToolsHariJadianRoute = ToolsHariJadianRouteImport.update({
            id: '/tools/hari-jadian',path: '/tools/hari-jadian',getParentRoute: () => rootRouteImport
          })
const ToolsCekWetonRoute = ToolsCekWetonRouteImport.update({
            id: '/tools/cek-weton',path: '/tools/cek-weton',getParentRoute: () => rootRouteImport
          })
const TanggalMerahYearRoute = TanggalMerahYearRouteImport.update({
            id: '/tanggal-merah/$year',path: '/tanggal-merah/$year',getParentRoute: () => rootRouteImport
          })
const LiburNasionalYearRoute = LiburNasionalYearRouteImport.update({
            id: '/libur-nasional/$year',path: '/libur-nasional/$year',getParentRoute: () => rootRouteImport
          })
const JadwalSholatLokasiRoute = JadwalSholatLokasiRouteImport.update({
            id: '/jadwal-sholat/lokasi',path: '/jadwal-sholat/lokasi',getParentRoute: () => rootRouteImport
          })
const JadwalSholatKotaRoute = JadwalSholatKotaRouteImport.update({
            id: '/jadwal-sholat/$kota',path: '/jadwal-sholat/$kota',getParentRoute: () => rootRouteImport
          })
const JadwalImsakLokasiRoute = JadwalImsakLokasiRouteImport.update({
            id: '/jadwal-imsak/lokasi',path: '/jadwal-imsak/lokasi',getParentRoute: () => rootRouteImport
          })
const JadwalImsakKotaRoute = JadwalImsakKotaRouteImport.update({
            id: '/jadwal-imsak/$kota',path: '/jadwal-imsak/$kota',getParentRoute: () => rootRouteImport
          })
const JadwalBukaPuasaLokasiRoute = JadwalBukaPuasaLokasiRouteImport.update({
            id: '/jadwal-buka-puasa/lokasi',path: '/jadwal-buka-puasa/lokasi',getParentRoute: () => rootRouteImport
          })
const JadwalBukaPuasaKotaRoute = JadwalBukaPuasaKotaRouteImport.update({
            id: '/jadwal-buka-puasa/$kota',path: '/jadwal-buka-puasa/$kota',getParentRoute: () => rootRouteImport
          })
const HariSlugRoute = HariSlugRouteImport.update({
            id: '/hari/$slug',path: '/hari/$slug',getParentRoute: () => rootRouteImport
          })
const EnTodayRoute = EnTodayRouteImport.update({
            id: '/en/today',path: '/en/today',getParentRoute: () => rootRouteImport
          })
const EnTermsRoute = EnTermsRouteImport.update({
            id: '/en/terms',path: '/en/terms',getParentRoute: () => rootRouteImport
          })
const EnTentangRoute = EnTentangRouteImport.update({
            id: '/en/tentang',path: '/en/tentang',getParentRoute: () => rootRouteImport
          })
const EnPrivacyPolicyRoute = EnPrivacyPolicyRouteImport.update({
            id: '/en/privacy-policy',path: '/en/privacy-policy',getParentRoute: () => rootRouteImport
          })
const EnHariIniRoute = EnHariIniRouteImport.update({
            id: '/en/hari-ini',path: '/en/hari-ini',getParentRoute: () => rootRouteImport
          })
const EnContactRoute = EnContactRouteImport.update({
            id: '/en/contact',path: '/en/contact',getParentRoute: () => rootRouteImport
          })
const EnAboutRoute = EnAboutRouteImport.update({
            id: '/en/about',path: '/en/about',getParentRoute: () => rootRouteImport
          })
const EnSlugRoute = EnSlugRouteImport.update({
            id: '/en/$slug',path: '/en/$slug',getParentRoute: () => rootRouteImport
          })
const DetailSlugRoute = DetailSlugRouteImport.update({
            id: '/detail/$slug',path: '/detail/$slug',getParentRoute: () => rootRouteImport
          })
const CutiBersamaYearRoute = CutiBersamaYearRouteImport.update({
            id: '/cuti-bersama/$year',path: '/cuti-bersama/$year',getParentRoute: () => rootRouteImport
          })
const _diagEnAliasesRoute = _diagEnAliasesRouteImport.update({
            id: '/__diag/en-aliases',path: '/en-aliases',getParentRoute: () => rootRouteImport
          })
const ZodiakCocokIndexRoute = ZodiakCocokIndexRouteImport.update({
            id: '/zodiak/cocok/',path: '/zodiak/cocok/',getParentRoute: () => rootRouteImport
          })
const KalenderYearIndexRoute = KalenderYearIndexRouteImport.update({
            id: '/kalender/$year/',path: '/kalender/$year/',getParentRoute: () => rootRouteImport
          })
const KalenderHijriahHyearIndexRoute = KalenderHijriahHyearIndexRouteImport.update({
            id: '/kalender-hijriah/$hyear/',path: '/kalender-hijriah/$hyear/',getParentRoute: () => rootRouteImport
          })
const HarpitnasSlugIndexRoute = HarpitnasSlugIndexRouteImport.update({
            id: '/harpitnas/$slug/',path: '/harpitnas/$slug/',getParentRoute: () => rootRouteImport
          })
const EnKalenderHijriahIndexRoute = EnKalenderHijriahIndexRouteImport.update({
            id: '/en/kalender-hijriah/',path: '/en/kalender-hijriah/',getParentRoute: () => rootRouteImport
          })
const EnHijriCalendarIndexRoute = EnHijriCalendarIndexRouteImport.update({
            id: '/en/hijri-calendar/',path: '/en/hijri-calendar/',getParentRoute: () => rootRouteImport
          })
const EnCalendarIndexRoute = EnCalendarIndexRouteImport.update({
            id: '/en/calendar/',path: '/en/calendar/',getParentRoute: () => rootRouteImport
          })
const ZodiakTanggalSlugRoute = ZodiakTanggalSlugRouteImport.update({
            id: '/zodiak/tanggal/$slug',path: '/zodiak/tanggal/$slug',getParentRoute: () => rootRouteImport
          })
const ZodiakCocokPairRoute = ZodiakCocokPairRouteImport.update({
            id: '/zodiak/cocok/$pair',path: '/zodiak/cocok/$pair',getParentRoute: () => rootRouteImport
          })
const KalenderYearSlugRoute = KalenderYearSlugRouteImport.update({
            id: '/kalender/$year/$slug',path: '/kalender/$year/$slug',getParentRoute: () => rootRouteImport
          })
const HarpitnasSlugMonthRoute = HarpitnasSlugMonthRouteImport.update({
            id: '/harpitnas/$slug/$month',path: '/harpitnas/$slug/$month',getParentRoute: () => rootRouteImport
          })
const EnToolsWetonCheckRoute = EnToolsWetonCheckRouteImport.update({
            id: '/en/tools/weton-check',path: '/en/tools/weton-check',getParentRoute: () => rootRouteImport
          })
const EnToolsKalkulatorHariRoute = EnToolsKalkulatorHariRouteImport.update({
            id: '/en/tools/kalkulator-hari',path: '/en/tools/kalkulator-hari',getParentRoute: () => rootRouteImport
          })
const EnToolsDayCalculatorRoute = EnToolsDayCalculatorRouteImport.update({
            id: '/en/tools/day-calculator',path: '/en/tools/day-calculator',getParentRoute: () => rootRouteImport
          })
const EnTanggalMerahYearRoute = EnTanggalMerahYearRouteImport.update({
            id: '/en/tanggal-merah/$year',path: '/en/tanggal-merah/$year',getParentRoute: () => rootRouteImport
          })
const EnRedDatesYearRoute = EnRedDatesYearRouteImport.update({
            id: '/en/red-dates/$year',path: '/en/red-dates/$year',getParentRoute: () => rootRouteImport
          })
const EnPublicHolidaysYearRoute = EnPublicHolidaysYearRouteImport.update({
            id: '/en/public-holidays/$year',path: '/en/public-holidays/$year',getParentRoute: () => rootRouteImport
          })
const EnLiburNasionalYearRoute = EnLiburNasionalYearRouteImport.update({
            id: '/en/libur-nasional/$year',path: '/en/libur-nasional/$year',getParentRoute: () => rootRouteImport
          })
const EnJointLeaveYearRoute = EnJointLeaveYearRouteImport.update({
            id: '/en/joint-leave/$year',path: '/en/joint-leave/$year',getParentRoute: () => rootRouteImport
          })
const EnDetailSlugRoute = EnDetailSlugRouteImport.update({
            id: '/en/detail/$slug',path: '/en/detail/$slug',getParentRoute: () => rootRouteImport
          })
const EnCutiBersamaYearRoute = EnCutiBersamaYearRouteImport.update({
            id: '/en/cuti-bersama/$year',path: '/en/cuti-bersama/$year',getParentRoute: () => rootRouteImport
          })
const EmbedJadwalSholatKotaRoute = EmbedJadwalSholatKotaRouteImport.update({
            id: '/embed/jadwal-sholat/$kota',path: '/embed/jadwal-sholat/$kota',getParentRoute: () => rootRouteImport
          })
const EmbedJadwalImsakKotaRoute = EmbedJadwalImsakKotaRouteImport.update({
            id: '/embed/jadwal-imsak/$kota',path: '/embed/jadwal-imsak/$kota',getParentRoute: () => rootRouteImport
          })
const EmbedJadwalBukaPuasaKotaRoute = EmbedJadwalBukaPuasaKotaRouteImport.update({
            id: '/embed/jadwal-buka-puasa/$kota',path: '/embed/jadwal-buka-puasa/$kota',getParentRoute: () => rootRouteImport
          })
const JadwalSholatKotaIndexRoute = JadwalSholatKotaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => JadwalSholatKotaRoute
          })
const JadwalSholatKotaKecRoute = JadwalSholatKotaKecRouteImport.update({
            id: '/$kec',path: '/$kec',getParentRoute: () => JadwalSholatKotaRoute
          })
const JadwalImsakKotaIndexRoute = JadwalImsakKotaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => JadwalImsakKotaRoute
          })
const JadwalImsakKotaKecRoute = JadwalImsakKotaKecRouteImport.update({
            id: '/$kec',path: '/$kec',getParentRoute: () => JadwalImsakKotaRoute
          })
const JadwalBukaPuasaKotaIndexRoute = JadwalBukaPuasaKotaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => JadwalBukaPuasaKotaRoute
          })
const JadwalBukaPuasaKotaKecRoute = JadwalBukaPuasaKotaKecRouteImport.update({
            id: '/$kec',path: '/$kec',getParentRoute: () => JadwalBukaPuasaKotaRoute
          })
const KalenderHijriahHyearHmonthIndexRoute = KalenderHijriahHyearHmonthIndexRouteImport.update({
            id: '/kalender-hijriah/$hyear/$hmonth/',path: '/kalender-hijriah/$hyear/$hmonth/',getParentRoute: () => rootRouteImport
          })
const EnKalenderHijriahHyearIndexRoute = EnKalenderHijriahHyearIndexRouteImport.update({
            id: '/en/kalender-hijriah/$hyear/',path: '/en/kalender-hijriah/$hyear/',getParentRoute: () => rootRouteImport
          })
const EnHijriCalendarHyearIndexRoute = EnHijriCalendarHyearIndexRouteImport.update({
            id: '/en/hijri-calendar/$hyear/',path: '/en/hijri-calendar/$hyear/',getParentRoute: () => rootRouteImport
          })
const EnCalendarYearIndexRoute = EnCalendarYearIndexRouteImport.update({
            id: '/en/calendar/$year/',path: '/en/calendar/$year/',getParentRoute: () => rootRouteImport
          })
const KalenderHijriahHyearHmonthHdayRoute = KalenderHijriahHyearHmonthHdayRouteImport.update({
            id: '/kalender-hijriah/$hyear/$hmonth/$hday',path: '/kalender-hijriah/$hyear/$hmonth/$hday',getParentRoute: () => rootRouteImport
          })
const EnCalendarYearSlugRoute = EnCalendarYearSlugRouteImport.update({
            id: '/en/calendar/$year/$slug',path: '/en/calendar/$year/$slug',getParentRoute: () => rootRouteImport
          })
const EmbedJadwalSholatKotaIndexRoute = EmbedJadwalSholatKotaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EmbedJadwalSholatKotaRoute
          })
const EmbedJadwalSholatKotaKecRoute = EmbedJadwalSholatKotaKecRouteImport.update({
            id: '/$kec',path: '/$kec',getParentRoute: () => EmbedJadwalSholatKotaRoute
          })
const EmbedJadwalImsakKotaIndexRoute = EmbedJadwalImsakKotaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EmbedJadwalImsakKotaRoute
          })
const EmbedJadwalImsakKotaKecRoute = EmbedJadwalImsakKotaKecRouteImport.update({
            id: '/$kec',path: '/$kec',getParentRoute: () => EmbedJadwalImsakKotaRoute
          })
const EmbedJadwalBukaPuasaKotaIndexRoute = EmbedJadwalBukaPuasaKotaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EmbedJadwalBukaPuasaKotaRoute
          })
const EmbedJadwalBukaPuasaKotaKecRoute = EmbedJadwalBukaPuasaKotaKecRouteImport.update({
            id: '/$kec',path: '/$kec',getParentRoute: () => EmbedJadwalBukaPuasaKotaRoute
          })
const EnKalenderHijriahHyearHmonthIndexRoute = EnKalenderHijriahHyearHmonthIndexRouteImport.update({
            id: '/en/kalender-hijriah/$hyear/$hmonth/',path: '/en/kalender-hijriah/$hyear/$hmonth/',getParentRoute: () => rootRouteImport
          })
const EnHijriCalendarHyearHmonthIndexRoute = EnHijriCalendarHyearHmonthIndexRouteImport.update({
            id: '/en/hijri-calendar/$hyear/$hmonth/',path: '/en/hijri-calendar/$hyear/$hmonth/',getParentRoute: () => rootRouteImport
          })
const EnHijriCalendarHyearHmonthHdayRoute = EnHijriCalendarHyearHmonthHdayRouteImport.update({
            id: '/en/hijri-calendar/$hyear/$hmonth/$hday',path: '/en/hijri-calendar/$hyear/$hmonth/$hday',getParentRoute: () => rootRouteImport
          })





const JadwalBukaPuasaKotaRouteChildren = {
  JadwalBukaPuasaKotaKecRoute: JadwalBukaPuasaKotaKecRoute,JadwalBukaPuasaKotaIndexRoute: JadwalBukaPuasaKotaIndexRoute
}

const JadwalBukaPuasaKotaRouteWithChildren = JadwalBukaPuasaKotaRoute._addFileChildren(JadwalBukaPuasaKotaRouteChildren)




const JadwalImsakKotaRouteChildren = {
  JadwalImsakKotaKecRoute: JadwalImsakKotaKecRoute,JadwalImsakKotaIndexRoute: JadwalImsakKotaIndexRoute
}

const JadwalImsakKotaRouteWithChildren = JadwalImsakKotaRoute._addFileChildren(JadwalImsakKotaRouteChildren)




const JadwalSholatKotaRouteChildren = {
  JadwalSholatKotaKecRoute: JadwalSholatKotaKecRoute,JadwalSholatKotaIndexRoute: JadwalSholatKotaIndexRoute
}

const JadwalSholatKotaRouteWithChildren = JadwalSholatKotaRoute._addFileChildren(JadwalSholatKotaRouteChildren)




const EmbedJadwalBukaPuasaKotaRouteChildren = {
  EmbedJadwalBukaPuasaKotaKecRoute: EmbedJadwalBukaPuasaKotaKecRoute,EmbedJadwalBukaPuasaKotaIndexRoute: EmbedJadwalBukaPuasaKotaIndexRoute
}

const EmbedJadwalBukaPuasaKotaRouteWithChildren = EmbedJadwalBukaPuasaKotaRoute._addFileChildren(EmbedJadwalBukaPuasaKotaRouteChildren)




const EmbedJadwalImsakKotaRouteChildren = {
  EmbedJadwalImsakKotaKecRoute: EmbedJadwalImsakKotaKecRoute,EmbedJadwalImsakKotaIndexRoute: EmbedJadwalImsakKotaIndexRoute
}

const EmbedJadwalImsakKotaRouteWithChildren = EmbedJadwalImsakKotaRoute._addFileChildren(EmbedJadwalImsakKotaRouteChildren)




const EmbedJadwalSholatKotaRouteChildren = {
  EmbedJadwalSholatKotaKecRoute: EmbedJadwalSholatKotaKecRoute,EmbedJadwalSholatKotaIndexRoute: EmbedJadwalSholatKotaIndexRoute
}

const EmbedJadwalSholatKotaRouteWithChildren = EmbedJadwalSholatKotaRoute._addFileChildren(EmbedJadwalSholatKotaRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,HariIniRoute: HariIniRoute,KebijakanPrivasiRoute: KebijakanPrivasiRoute,KontakRoute: KontakRoute,SyaratKetentuanRoute: SyaratKetentuanRoute,TentangRoute: TentangRoute,_diagEnAliasesRoute: _diagEnAliasesRoute,CutiBersamaYearRoute: CutiBersamaYearRoute,DetailSlugRoute: DetailSlugRoute,EnSlugRoute: EnSlugRoute,EnAboutRoute: EnAboutRoute,EnContactRoute: EnContactRoute,EnHariIniRoute: EnHariIniRoute,EnPrivacyPolicyRoute: EnPrivacyPolicyRoute,EnTentangRoute: EnTentangRoute,EnTermsRoute: EnTermsRoute,EnTodayRoute: EnTodayRoute,HariSlugRoute: HariSlugRoute,JadwalBukaPuasaKotaRoute: JadwalBukaPuasaKotaRouteWithChildren,JadwalBukaPuasaLokasiRoute: JadwalBukaPuasaLokasiRoute,JadwalImsakKotaRoute: JadwalImsakKotaRouteWithChildren,JadwalImsakLokasiRoute: JadwalImsakLokasiRoute,JadwalSholatKotaRoute: JadwalSholatKotaRouteWithChildren,JadwalSholatLokasiRoute: JadwalSholatLokasiRoute,LiburNasionalYearRoute: LiburNasionalYearRoute,TanggalMerahYearRoute: TanggalMerahYearRoute,ToolsCekWetonRoute: ToolsCekWetonRoute,ToolsHariJadianRoute: ToolsHariJadianRoute,ToolsHariLahirRoute: ToolsHariLahirRoute,ToolsHariLdrRoute: ToolsHariLdrRoute,ToolsHariMenikahRoute: ToolsHariMenikahRoute,ToolsHariPutusRoute: ToolsHariPutusRoute,ToolsHariSahabatRoute: ToolsHariSahabatRoute,ToolsKalkulatorHariRoute: ToolsKalkulatorHariRoute,ZodiakSignRoute: ZodiakSignRoute,EnIndexRoute: EnIndexRoute,HariIndexRoute: HariIndexRoute,HarpitnasIndexRoute: HarpitnasIndexRoute,JadwalBukaPuasaIndexRoute: JadwalBukaPuasaIndexRoute,JadwalImsakIndexRoute: JadwalImsakIndexRoute,JadwalSholatIndexRoute: JadwalSholatIndexRoute,KalenderHijriahIndexRoute: KalenderHijriahIndexRoute,KalenderIndexRoute: KalenderIndexRoute,KalkulatorIndexRoute: KalkulatorIndexRoute,ToolsIndexRoute: ToolsIndexRoute,ZodiakIndexRoute: ZodiakIndexRoute,EmbedJadwalBukaPuasaKotaRoute: EmbedJadwalBukaPuasaKotaRouteWithChildren,EmbedJadwalImsakKotaRoute: EmbedJadwalImsakKotaRouteWithChildren,EmbedJadwalSholatKotaRoute: EmbedJadwalSholatKotaRouteWithChildren,EnCutiBersamaYearRoute: EnCutiBersamaYearRoute,EnDetailSlugRoute: EnDetailSlugRoute,EnJointLeaveYearRoute: EnJointLeaveYearRoute,EnLiburNasionalYearRoute: EnLiburNasionalYearRoute,EnPublicHolidaysYearRoute: EnPublicHolidaysYearRoute,EnRedDatesYearRoute: EnRedDatesYearRoute,EnTanggalMerahYearRoute: EnTanggalMerahYearRoute,EnToolsDayCalculatorRoute: EnToolsDayCalculatorRoute,EnToolsKalkulatorHariRoute: EnToolsKalkulatorHariRoute,EnToolsWetonCheckRoute: EnToolsWetonCheckRoute,HarpitnasSlugMonthRoute: HarpitnasSlugMonthRoute,KalenderYearSlugRoute: KalenderYearSlugRoute,ZodiakCocokPairRoute: ZodiakCocokPairRoute,ZodiakTanggalSlugRoute: ZodiakTanggalSlugRoute,EnCalendarIndexRoute: EnCalendarIndexRoute,EnHijriCalendarIndexRoute: EnHijriCalendarIndexRoute,EnKalenderHijriahIndexRoute: EnKalenderHijriahIndexRoute,HarpitnasSlugIndexRoute: HarpitnasSlugIndexRoute,KalenderHijriahHyearIndexRoute: KalenderHijriahHyearIndexRoute,KalenderYearIndexRoute: KalenderYearIndexRoute,ZodiakCocokIndexRoute: ZodiakCocokIndexRoute,EnCalendarYearSlugRoute: EnCalendarYearSlugRoute,KalenderHijriahHyearHmonthHdayRoute: KalenderHijriahHyearHmonthHdayRoute,EnCalendarYearIndexRoute: EnCalendarYearIndexRoute,EnHijriCalendarHyearIndexRoute: EnHijriCalendarHyearIndexRoute,EnKalenderHijriahHyearIndexRoute: EnKalenderHijriahHyearIndexRoute,KalenderHijriahHyearHmonthIndexRoute: KalenderHijriahHyearHmonthIndexRoute,EnHijriCalendarHyearHmonthHdayRoute: EnHijriCalendarHyearHmonthHdayRoute,EnHijriCalendarHyearHmonthIndexRoute: EnHijriCalendarHyearHmonthIndexRoute,EnKalenderHijriahHyearHmonthIndexRoute: EnKalenderHijriahHyearHmonthIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)